import {BLOCK_TYPE_ACCREDITATION_ID} from '../types';

export default function validate(formProps) {
    const errors = {};

    if (!formProps.block_type_id) {
        errors.block_type_id =
            'Block Type is required! Please select a block type for your block!';
    }

    if (!formProps.name) {
        errors.name =
            'Name field is required! Please enter a name for your block!';
    }

    if (
        !formProps.body &&
        formProps.block_type_id !== BLOCK_TYPE_ACCREDITATION_ID
    ) {
        errors.body =
            'Body field is required! Please enter a body for your block!';
    } else if (formProps.body && formProps.body.length < 5) {
        errors.body = 'Please enter a minimum of 5 characters!';
    }

    if (formProps.title && formProps.title.length < 5) {
        errors.title = 'Please enter a minimum of 5 characters!';
    }

    return errors;
}



// WEBPACK FOOTER //
// ./src/containers/blocks/forms/validation.js